import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_link = _resolveComponent("g-link");
    return (_openBlock(), _createBlock(_component_g_link, {
        onLinkClick: _ctx.onExpand,
        src: _ctx._hasChildren ? '' : (_ctx.dataItem.actionCommand ? _ctx.dataItem.actionCommand : 'to://' + _ctx.dataItem.address),
        target: _ctx.dataItem?.actionTarget,
        class: "z-navicat-header_listItem"
    }, {
        default: _withCtx(() => [
            (_ctx.dataItem?.iconUrl)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.dataItem?.iconUrl,
                    class: "z-navicat-header_subCategoryIcon"
                }, null, 8, _hoisted_1))
                : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.label), 1)
        ]),
        _: 1
    }, 8, ["onLinkClick", "src", "target"]));
}
